module.exports = __webpack_public_path__ + "tree-diamond.svg?2fdd8239c94d99bcfd65ce8eda623827";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tree-diamond.svg
// module id = 158
// module chunks = 0